import * as styles from '../../styles/components/UserDashboards.less';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../common/Loader';
import { withTranslation, WithTranslation } from "react-i18next";
import { useActions } from '../../hooks/useActions';
import { useAppSelector } from '../../store/hooks';
import { EntityId } from '../../types/models';

interface UserCustomersOwnProps {
  onSetFilter: (list: EntityId[]) => void;
  className?: string;
  isLoading?: boolean;
}

const UserCustomers = (props: UserCustomersOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]
  const actions = useActions();
  const navigate = useNavigate();
  const customers = useAppSelector((store) => store.customer.customers);
  const [showDisabledCustomers, setShowDisabledCustomers] = useState(false);
  // Mutated in place and not used for rendering (matches the old instance field).
  const filterCustomers = useRef<EntityId[]>([]);

  useEffect(() => {
    actions.fetchUserCustomers();
  }, [actions]);

  // Render all customers not disabled at the 1st time rendered.
  // - Ticking 'Show disabled customers' rendered all.
  const renderCustomers = () => customers.map((customer, i) => (
    <div key={i} style={{display: 'flex'}}>
      <div className={(!customer.disabled || showDisabledCustomers) ? props.className : 'hidden'}>
        <input
          type="checkbox"
          style={{float: 'left', marginRight:'1rem'}}
          onChange={(e) => setFilterCustomers(customer.id, e)}
        />
        <button style={{visibility: 'hidden', background: 'white', marginRight: '0.5rem'}}
          key={i}
          onClick={() => navigate('/customer/' + customer.id)}>
          <i className="fa fa-users" aria-hidden="true" style={{opacity: 0.5}}></i>
        </button>
        <Link
          className={styles.dashboard}
          style={{float: 'left', color: customer.disabled ? 'grey' : 'green'}}
          to={`/customer/${customer.id}`}
          >{customer.name}
        </Link>
      </div>
    </div>
  ));

  // Boolean toggle tickbox handler
  const toggleShowDisabled = (_event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDisabledCustomers((prev) => !prev);
  };

  // Update customer filter array — checked ids are kept in the list.
  const setFilterCustomers = (id: EntityId, event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const filterList = filterCustomers.current;
    const inx = filterList.indexOf(id);
    if (inx > -1) {
      if (!checked) {
        filterList.splice(inx, 1); // drop
      }
    } else if (checked) {
      filterList.push(id); // add
    }
    // Pass a fresh copy, not the mutated ref: the parent stores this in useState,
    // and React bails out of re-rendering when the new value is the same reference
    // as the old one — which broke unchecking (and every toggle after the first).
    const next = [...filterList];
    props.onSetFilter(next); // push to parent
  };

  return (
    <div>
      <h2 className={styles.title}>
        {t('main.customers')}
        <Link className="button success" to="/customer/0">
          <i className="fa fa-plus-square"></i>
        </Link>
      </h2>
      <label>
        <input
          type="checkbox"
          onChange={toggleShowDisabled}
        />
        {t('customer.showDisabled')}
      </label>
      {props.isLoading && <Loader />}
      <div style={{height:"0.4em"}}></div>
      {renderCustomers()}
    </div>
  );
};

export default withTranslation('common')(UserCustomers);
